import React from "react";
import HoverEffect from "../hover-effect/HoverEffect";

// Example component that uses the HoverEffect
const ExampleComponent = () => {
  return (
    <>
      <div className="title">Buttons with Hover Effect</div>
      <div className="mb-4"></div>
      <div className="buttons is-centered">
        {/* Wrap the component you want to have this effect by simply wrapping it
            - Note that you can achieve the same effect by using the individual CSS
        */}
        <HoverEffect>
          <button class="button is-white">One</button>
        </HoverEffect>
        <HoverEffect>
          <button class="button is-white">Two</button>
        </HoverEffect>
        <HoverEffect>
          <button class="button is-white">Three</button>
        </HoverEffect>
      </div>
      <div className="mb-4"></div>
      <HoverEffect>
        <div className="box is-light">
          <div className="content is-medium">
            <p>This is a paragraph with hover effect</p>
          </div>
        </div>
      </HoverEffect>
    </>
  );
};

export default ExampleComponent;
